export const TypesData = [
 {
     id: 0, 
     a:10,
     b:10,
     c:10,
     d:10,
     e:10,
     f:10,
     g:10,
     h:10,
     i:10,
     j:10,
     k:10,
     l:10,
     m:10,
     n:10,
     o:10,
     p:10,
     q:10,
     r:10
 },
 {
    id:"normal", 
     a:10,
     b:20,
     c:10,
     d:10,
     e:10,
     f:10,
     g:10,
     h:0,
     i:10,
     j:10,
     k:10,
     l:10,
     m:10,
     n:10,
     o:10,
     p:10,
     q:10,
     r:10
},
{   
    id:"FIGHTING",
     a:10,
     b:10,
     c:20,
     d:10,
     e:10,
     f:5,
     g:5,
     h:10,
     i:10,
     j:10,
     k:10,
     l:10,
     m:10,
     n:20,
     o:10,
     p:10,
     q:5,
     r:20
},
{   
    id:"FLYING",
     a:10,
     b:5,
     c:10,
     d:10,
     e:0,
     f:20,
     g:5,
     h:10,
     i:10,
     j:10,
     k:10,
     l:5,
     m:20,
     n:10,
     o:20,
     p:10,
     q:10,
     r:10
},
{   
    id:"POISON",
     a:10,
     b:5,
     c:10,
     d:5,
     e:20,
     f:10,
     g:5,
     h:10,
     i:10,
     j:10,
     k:10,
     l:5,
     m:10,
     n:20,
     o:10,
     p:10,
     q:10,
     r:5
},
{   
    id:"GROUND",
     a:10,
     b:10,
     c:10,
     d:5,
     e:10,
     f:5,
     g:10,
     h:10,
     i:10,
     j:10,
     k:20,
     l:20,
     m:0,
     n:10,
     o:20,
     p:10,
     q:10,
     r:10
},
{   
    id:"ROCK",
     a:5,
     b:20,
     c:5,
     d:5,
     e:20,
     f:10,
     g:10,
     h:10,
     i:20,
     j:5,
     k:20,
     l:20,
     m:10,
     n:10,
     o:10,
     p:10,
     q:10,
     r:10
},
{   
    id:"BUG",
     a:10,
     b:5,
     c:20,
     d:10,
     e:5,
     f:20,
     g:10,
     h:10,
     i:10,
     j:20,
     k:10,
     l:5,
     m:10,
     n:10,
     o:10,
     p:10,
     q:10,
     r:10
},
{   
    id:"GHOST",
     a:0,
     b:0,
     c:10,
     d:5,
     e:10,
     f:10,
     g:5,
     h:20,
     i:10,
     j:10,
     k:10,
     l:10,
     m:10,
     n:10,
     o:10,
     p:10,
     q:20,
     r:10
},
{   
    id:"STEEL",
     a:5,
     b:20,
     c:5,
     d:0,
     e:20,
     f:5,
     g:5,
     h:10,
     i:5,
     j:20,
     k:10,
     l:5,
     m:10,
     n:5,
     o:5,
     p:5,
     q:10,
     r:5
},
{   
    id:"FIRE",
     a:10,
     b:10,
     c:10,
     d:10,
     e:20,
     f:20,
     g:5,
     h:10,
     i:5,
     j:5,
     k:20,
     l:5,
     m:10,
     n:10,
     o:5,
     p:10,
     q:10,
     r:5
},
{   
    id:"WATER",
     a:10,
     b:10,
     c:10,
     d:10,
     e:10,
     f:10,
     g:10,
     h:10,
     i:5,
     j:5,
     k:5,
     l:20,
     m:20,
     n:10,
     o:5,
     p:10,
     q:10,
     r:10
},
{   
    id:"GRASS",
     a:10,
     b:10,
     c:20,
     d:20,
     e:5,
     f:10,
     g:20,
     h:10,
     i:10,
     j:20,
     k:5,
     l:5,
     m:5,
     n:10,
     o:20,
     p:10,
     q:10,
     r:10
},
{   
    id:"ELECTRIC",
     a:10,
     b:10,
     c:5,
     d:10,
     e:20,
     f:10,
     g:10,
     h:10,
     i:5,
     j:10,
     k:10,
     l:10,
     m:5,
     n:10,
     o:10,
     p:10,
     q:10,
     r:10
},
{   
    id:"PSYCHIC",
     a:10,
     b:5,
     c:10,
     d:10,
     e:10,
     f:10,
     g:20,
     h:20,
     i:10,
     j:10,
     k:10,
     l:10,
     m:10,
     n:5,
     o:10,
     p:10,
     q:20,
     r:10
},
{   
    id:"ICE",
     a:10,
     b:20,
     c:10,
     d:10,
     e:10,
     f:20,
     g:10,
     h:10,
     i:20,
     j:20,
     k:10,
     l:10,
     m:10,
     n:10,
     o:5,
     p:10,
     q:10,
     r:10
},
{   
    id:"DRAGON",
     a:10,
     b:10,
     c:10,
     d:10,
     e:10,
     f:10,
     g:10,
     h:10,
     i:10,
     j:5,
     k:5,
     l:5,
     m:5,
     n:10,
     o:20,
     p:20,
     q:10,
     r:20
},
{   
    id:"DARK",
     a:10,
     b:20,
     c:10,
     d:10,
     e:10,
     f:10,
     g:20,
     h:5,
     i:10,
     j:10,
     k:10,
     l:10,
     m:10,
     n:0,
     o:10,
     p:10,
     q:5,
     r:20
},
{   
    id:"FAIRY",
     a:10,
     b:5,
     c:10,
     d:20,
     e:10,
     f:10,
     g:5,
     h:10,
     i:20,
     j:10,
     k:10,
     l:10,
     m:10,
     n:10,
     o:10,
     p:0,
     q:5,
     r:10
},
 ]
